import { createAction, props } from '@ngrx/store';
import { IMaritalData, IMaritalModel } from '@partners/api';

export class MaritalActions {
  static reset = createAction('[Marital] Reset State');
  static load = createAction('[Marital] Load');
  static loadSuccess = createAction('[Marital] Load Success', props<{ model: IMaritalModel; data: IMaritalData }>());
  static loadFailure = createAction('[Marital] Load Failure', props<{ error: any }>());
  static submit = createAction('[Marital] Submit');
  static submitSuccess = createAction(
    '[Marital] Submit Success',
    props<{ model: IMaritalModel; data: IMaritalData }>()
  );
  static submitFailure = createAction('[Marital] Submit Failure', props<{ error: any }>());
}
